module.exports = __webpack_public_path__ + "assets/1315524b25b8d9afbbc8025e9c97a42a.png";